import { getPricingOfAccountEmailFinderCampaign } from "../types/account_campaign_pricing_email_finder_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function accountCampaignPricingEmailFinderReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountEmailFinderCampaign.GET_PRICING_OF_ACCOUNT_EMAIL_FINDER_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
